import { render, staticRenderFns } from "./assembleCubic.vue?vue&type=template&id=466037d3&scoped=true&"
import script from "./assembleCubic.vue?vue&type=script&lang=js&"
export * from "./assembleCubic.vue?vue&type=script&lang=js&"
import style0 from "./assembleCubic.vue?vue&type=style&index=0&id=466037d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466037d3",
  null
  
)

export default component.exports